import { Clear } from '@mui/icons-material';
import React from 'react';

/**
 * @param {Function} [closeDispatchFunc] - Callback function when close button is clicked
 */
function CardActionButtons({ closeDispatchFunc = undefined }) {
  return (
    <Clear className="clear" onClick={closeDispatchFunc} />
  );
}

export default CardActionButtons;
